import { CompanyExtension, Extension, ExtensionGUID } from "@builder/types/Extension.type";

export const isExtensionInstalled = (extensions: Extension[], companyExtensions: CompanyExtension[], extensionGUID: ExtensionGUID) => {
    const selectedExtension = extensions.find(extension => extension.guid === extensionGUID);
    if (!selectedExtension) return false;

    return companyExtensions.some(companyExtension => companyExtension.extensionId === selectedExtension?._id);
};
